import React, { useState } from "react";
import {
  Button,
  Chart,
  ChartNew,
  Chip,
  Drawer,
  ExpandableWrapper,
  InfoCardNewAdv,
  InfoWrapper,
  Modal,
  ProgressBar,
  SmartTooltip,
  TableAdv,
} from "../../../components";
import { useLoginUser } from "../../../hooks/useLoginUser";
import dayjs from "dayjs";
import KpiViewModal from "./Modals/KpiViewModal";
import InvoiceDetails from "../Invoices/Invoices/InvoiceDetails";
import { mapTableRows } from "../../../utils";
import { useDispatch } from "react-redux";
import { usePagination } from "../../../hooks";
import { getCurrentInvoiceStart } from "../../../redux/slices/invoices/invoicesSlice";

const agingReportColumns = [
  {
    key: "clientName",
    label: "Client Name",
  },
  { key: "1-30", label: "1-30" },
  { key: "30-60", label: "30-60" },
  {
    key: "60-90",
    label: "60-90",
  },
];

const agingReportRows = Array.from({ length: 6 }, (_, i) => ({
  clientName: `IBM`,
  "1-30": `1040${i + 1}`,
  "30-60": `0`,
  "60-90": `10400`,
}));

const infographicColumns = [
  {
    key: "documentType",
    label: "Document Type",
  },
  { key: "candidateName", label: "Candidate Name" },
  { key: "expiryDate", label: "Expiry Date" },
  {
    key: "expiryIn",
    label: "Expiry In",
  },
];

const infographicRows = [
  {
    documentType: "H1B",
    candidateName: "Vikranth",
    expiryDate: "09/20/2025",
    expiryIn: <Chip label="4 Days" variant="text" color="success" />,
  },
  {
    documentType: "H1B",
    candidateName: "Chandan",
    expiryDate: "09/20/2025",
    expiryIn: <Chip label="-2 Days" variant="text" color="danger" />,
  },
  {
    documentType: "H1B",
    candidateName: "Omkar",
    expiryDate: "09/20/2025",
    expiryIn: <Chip label="4 Days" variant="text" color="success" />,
  },
  {
    documentType: "H1B",
    candidateName: "Ershad",
    expiryDate: "09/20/2025",
    expiryIn: <Chip label="3 Days" variant="text" color="success" />,
  },
  {
    documentType: "H1B",
    candidateName: "Chandan",
    expiryDate: "09/20/2025",
    expiryIn: <Chip label="-2 Days" variant="text" color="danger" />,
  },
  {
    documentType: "H1B",
    candidateName: "Ershad",
    expiryDate: "09/20/2025",
    expiryIn: <Chip label="3 Days" variant="text" color="success" />,
  },
];

const infoCards = [
  {
    title: "All Invoices",
    value: "25,00,000",
    prefix: "$",
  },
  {
    title: "Open Invoices",
    value: "21,00,000",
  },
  { title: "Due Invoices", value: "4,00,000" },
  { title: "Paid Invoices", value: "17,00,000" },
];

const revenuwExpandCards = [
  { title: "Jan", value: 55, prefix: "$" },
  { title: "Feb", value: 85, prefix: "$" },
  { title: "Mar", value: 140, prefix: "$" },
  { title: "Apr", value: 130, prefix: "$" },
  { title: "May", value: 100, prefix: "$" },
  { title: "Jun", value: 140, prefix: "$" },
  { title: "Jul", value: 160, prefix: "$" },
  { title: "Aug", value: 130, prefix: "$" },
  { title: "Sep", value: 100, prefix: "$" },
  { title: "Oct", value: 100, prefix: "$" },
  { title: "Nov", value: 130, prefix: "$" },
  { title: "Dec", value: 170, prefix: "$" },
];

const MainDashboard = () => {
  const { userData: loginUserData } = useLoginUser();
  const [revenueFlowModalOpen, setRevenueFlowModalOpen] = useState(false);
  const [isOPenWidget, setIsOpenWidget] = useState(false);
  const [selectedWidgets, setSelectedWidgets] = useState([]);

  const widgets = [
    "All Employees",
    "Revenue",
    "Timesheets",
    "Aging Report",
    "Funding",
    "Active Billing",
    "IT Revenue",
    "Non-IT Revenue",
  ];

  const handleSelectWidgets = (item) => {
    if (selectedWidgets.includes(item)) {
      setSelectedWidgets(selectedWidgets.filter((val) => item !== val));
    } else {
      setSelectedWidgets([...selectedWidgets, item]);
    }
  };

  const renderInfoBarExpandContent = () => (
    <div className="grid grid-cols-4 gap-5 mx-15 py-4">
      <div className="flex flex-col bg-success-50 border border-success rounded-xl p-4 ">
        <span className="text-success-700 text-2xl font-semibold">$610</span>
        <p className="py-2">Total Revenue</p>
        <span className="text-success text-sm">100% of Data</span>
      </div>

      <div className="flex flex-col bg-info-50 border border-info rounded-xl p-4 ">
        <span className="text-info-700 text-2xl font-semibold">$180</span>
        <p className="py-2">Peak Value</p>
        <span className="text-info text-sm">Best Period</span>
      </div>

      <div className="flex flex-col bg-leave-50 border border-leave rounded-xl p-4 ">
        <span className="text-leave-700 text-2xl font-semibold">$122</span>
        <p className="py-2">Average</p>
        <span className="text-leave text-sm">Per Period</span>
      </div>

      <div className="flex flex-col bg-warning-50 border border-warning rounded-xl p-4 ">
        <span className="text-warning-700 text-2xl font-semibold">5</span>
        <p className="py-2">Time Periods</p>
        <span className="text-warning text-sm">Data Points</span>
      </div>
    </div>
  );

  const renderRevenueExpandContent = () => (
    <div className="flex flex-col gap-8 mx-10 py-4">
      <div className="grid grid-cols-12 gap-5 mx-3">
        {revenuwExpandCards.map((data) => (
          <div className="flex flex-col items-center px-5 py-3 rounded-xl border-2 border-gray-200 shadow-md">
            <span className="text-primary">{data.title}</span>
            <ProgressBar
              value={data.value}
              maxValue={200}
              height="h-2"
              width="w-20"
              className={"my-2"}
            />
            <span className="text-xlfont-semibold">
              {data.prefix || ""}
              {data.value}
            </span>
            <span
              className="text-sm text-info mt-1 cursor-pointer"
              //here i have used static value because it is working with static value 22
              onClick={() => setRevenueFlowModalOpen(22)}
            >
              22
            </span>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-4 gap-5">
        <div className="flex flex-col bg-success-50 border border-success rounded-xl p-4 ">
          <span className="text-success-700 text-2xl font-semibold">
            $ 1650
          </span>
          <p className="py-2">Total Revenues</p>
          <span className="text-success text-sm">12 Months</span>
        </div>

        <div className="flex flex-col bg-info-50 border border-info rounded-xl p-4 ">
          <span className="text-info-700 text-2xl font-semibold">448</span>
          <p className="py-2">Total Invoices</p>
          <span className="text-info text-sm">All Periods</span>
        </div>

        <div className="flex flex-col bg-leave-50 border border-leave rounded-xl p-4 ">
          <span className="text-leave-700 text-2xl font-semibold">$ 138</span>
          <p className="py-2">Average Monthly</p>
          <span className="text-leave text-sm">Revenue</span>
        </div>

        <div className="flex flex-col bg-warning-50 border border-warning rounded-xl p-4 ">
          <span className="text-warning-700 text-2xl font-semibold">37</span>
          <p className="py-2">Average Invoices</p>
          <span className="text-warning text-sm">Per Month</span>
        </div>
      </div>
    </div>
  );
  const RevenueFlowKpiViewModal = ({ isOpen, onClose, data }) => {
    const dispatch = useDispatch();
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const { page, limit, setPage, handleLimitChange } = usePagination(
      10,
      (newPage, newLimit) => {},
    );

    const rows = [
      {
        id: 1,
        uiid: 541,
        invoiceDate: "02/02/2026",
        transactionType: "Invoice",
        number: "16946",
        name: "NTT DATA Service Federal Gov.",
        memo: "Ravindra Rao (01/01/2026)",
        dueDate: "03/04/2026",
        amount: "19,950.00",
        openingBalance: "19,950.00",
      },
      {
        id: 2,
        uiid: 542,
        invoiceDate: "02/05/2026",
        transactionType: "Invoice",
        number: "16942",
        name: "Accenture LLP",
        memo: "Michael Scott (01/15/2026)",
        dueDate: "03/07/2026",
        amount: "12,500.00",
        openingBalance: "12,500.00",
      },
      {
        id: 3,
        uiid: 543,
        invoiceDate: "02/08/2026",
        transactionType: "Bill",
        number: "16951",
        name: "Deloitte Consulting",
        memo: "Sarah Johnson (01/20/2026)",
        dueDate: "03/10/2026",
        amount: "8,750.00",
        openingBalance: "8,750.00",
      },
      {
        id: 4,
        uiid: 544,
        invoiceDate: "02/10/2026",
        transactionType: "Invoice",
        number: "16950",
        name: "Infosys Ltd.",
        memo: "David Miller (01/25/2026)",
        dueDate: "03/12/2026",
        amount: "22,300.00",
        openingBalance: "22,300.00",
      },
      {
        id: 5,
        uiid: 545,
        invoiceDate: "02/12/2026",
        transactionType: "Credit Note",
        number: "16949",
        name: "Capgemini America",
        memo: "Emily Davis (01/28/2026)",
        dueDate: "03/14/2026",
        amount: "-3,200.00",
        openingBalance: "-3,200.00",
      },
      {
        id: 6,
        uiid: 546,
        invoiceDate: "02/15/2026",
        transactionType: "Invoice",
        number: "16948",
        name: "IBM Corporation",
        memo: "Robert Brown (02/01/2026)",
        dueDate: "03/17/2026",
        amount: "15,600.00",
        openingBalance: "15,600.00",
      },
      {
        id: 7,
        uiid: 547,
        invoiceDate: "02/18/2026",
        transactionType: "Bill",
        number: "16947",
        name: "Cognizant Technology",
        memo: "Olivia Wilson (02/05/2026)",
        dueDate: "03/20/2026",
        amount: "9,400.00",
        openingBalance: "9,400.00",
      },
      {
        id: 8,
        uiid: 548,
        invoiceDate: "02/20/2026",
        transactionType: "Invoice",
        number: "16952",
        name: "Tata Consultancy Services",
        memo: "James Anderson (02/07/2026)",
        dueDate: "03/22/2026",
        amount: "18,250.00",
        openingBalance: "18,250.00",
      },
    ];
    const columns = [
      { key: "invoiceDate", label: "Invoice Date", width: "text-nowrap!" },
      {
        key: "transactionType",
        label: "Transaction Type",
        width: "text-nowrap!",
      },
      {
        key: "number",
        label: "Number",
        width: "text-nowrap!",
        render: (row) => (
          <div
            className="text-info-500 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              dispatch(
                getCurrentInvoiceStart({
                  filters: { uiid: { type: "NONE", value: row.uiid } },
                  coll: "Invoice",
                  ref: "Client Employee Placement Timesheet",
                  incl: ["", "firstName lastName", "", "attachments"],
                }),
              );
              setSelectedInvoice(row?.number);
            }}
          >
            {row?.number}
          </div>
        ),
      },
      {
        key: "name",
        label: "Name",
        width: "min-w-[250px]! max-w-[300px]!",
        render: (row) => (
          <SmartTooltip
            description={row.name}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="line-clamp-1!">{row?.name}</div>
          </SmartTooltip>
        ),
      },
      {
        key: "memo",
        label: "Memo/ Description",
        width: "min-w-[250px]! max-w-[300px]!",
        render: (row) => (
          <SmartTooltip
            description={row.memo}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="line-clamp-1!">{row?.memo}</div>
          </SmartTooltip>
        ),
      },
      { key: "dueDate", label: "Due Date", width: "text-nowrap!" },
      { key: "amount", label: "Amount", width: "text-nowrap!" },
      {
        key: "openingBalance",
        label: "Opening Balance",
        width: "text-nowrap!",
      },
    ];
    const mappedRows = mapTableRows(rows, columns);
    return (
      <div>
        <div className="flex gap-3">
          <Button
            size="md"
            title={"Back"}
            variant="text"
            icon={"arrow_left_alt"}
            color="black"
            className="px-0! bg-transparent!"
            onClick={onClose}
          />
        </div>
        <div className="flex-1 overflow-auto flex gap-4 p-0.5">
          <TableAdv
            tableId={"dashboard_maindashboardrevenueflowkpi"}
            showSlNo
            columns={columns}
            rows={mappedRows}
            totalCount={rows?.length}
            page={page}
            limit={limit}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
            toolbarRight={{
              search: true,
            }}
          />
        </div>
        <Modal
          isOpen={selectedInvoice}
          title={"Invoice Details"}
          onClose={() => setSelectedInvoice(null)}
          showCloseButton={true}
          closeOnOutsideClick={true}
          width="max-w-full"
        >
          <InvoiceDetails
            invoice={selectedInvoice}
            onBack={() => setSelectedInvoice(null)}
            removeButtonForPreview={true}
            // setReceivePayment={handleGoToReceivePayment}
          />
        </Modal>
      </div>
    );
  };

  return (
    <div>
      <div className="bg-[#FAFCFF] col-span-2 flex flex-col px-3 py-4 border border-gray-200 rounded-2xl shadow-lg">
        <div className="flex justify-between items-center mb-1">
          <p>
            Good{" "}
            {dayjs().hour() < 12
              ? "Morning"
              : dayjs().hour() < 17
                ? "Afternoon"
                : "Evening"}
            , {loginUserData?.firstName ?? ""} {loginUserData?.lastName ?? ""}
          </p>
          <Button
            title={"Add Widget"}
            variant="outlined"
            icon={"add"}
            active={true}
            onClick={() => setIsOpenWidget(true)}
          />
        </div>

        {/* <div className="grid grid-cols-4 gap-8 mt-4"> */}
        {/* <InfoWrapper>
          {infoCards.map((item, _idx) => (
            <InfoTimeCardAdv
              key={_idx}
              type="type3"
              title={item.title}
              value={item.value}
              prefix={item.prefix || ""}
              variant="contained"
              color="primary"
            />
          ))}

        </InfoWrapper> */}
        <InfoWrapper className={"mt-2"}>
          {infoCards?.map((item, _idx) => (
            <InfoCardNewAdv
              key={_idx}
              title={item?.title}
              value={item?.value}
              prefix={item?.prefix || ""}
              layout="option9"
            />
          ))}
        </InfoWrapper>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 px-1 py-2">
        <div className="bg-[#FAFCFF] h-[340px] px-3 py-4 border border-gray-200 rounded-2xl shadow-lg col-span-2 lg:col-span-1">
          <ChartNew
            type="barchart"
            title="Infographic Bar"
            expandedContent={renderInfoBarExpandContent()}
            expandedChartWidth="w-[70%]"
            expandedChartHeight="h-[400px]"
            barColors={[
              { color: "primary" },
              { color: "info" },
              { color: "leave" },
              { color: "draft", depth: 500 },
              { color: "success" },
            ]}
            rawData={[
              { label: "0-30", value: 4 },
              { label: "30-60", value: 12 },
              { label: "60-90", value: 16 },
              { label: "90-120", value: 25 },
              { label: "120-150", value: 18 },
            ]}
            chartLabel={"label"}
            chartValue={"value"}
            barChartProps={{
              steps: 5,
              depth: 300,
              barWidth: "60px",
              backgroundColor: "bg-[#FAFCFF]",
            }}
            formatYAxisTick={(val) => `$ ${val}`}
          />
        </div>

        <div className="bg-[#FAFCFF] h-[340px] px-3 py-4 border border-gray-200 rounded-2xl shadow-lg col-span-2 lg:col-span-1">
          <ChartNew
            title="Aging Report"
            expandIcon={false}
            type="tablechart"
            barColors={[
              { color: "primary" },
              { color: "info" },
              { color: "leave" },
              { color: "draft", depth: 500 },
              { color: "success" },
            ]}
            rawData={[
              {
                clientName: "IBM",
                "1-30": 360,
                "30-60": 0,
                "60-90": 560,
                paymentDate: "03 Sep, 2025",
              },
              {
                clientName: "tCS",
                "1-30": 230,
                "30-60": 0,
                "60-90": 560,
                paymentDate: "08 sep, 2025",
              },
              {
                clientName: "INFOSYS",
                "1-30": 190,
                "30-60": 0,
                "60-90": 560,
                paymentDate: "03 Jul, 2025",
              },
              {
                clientName: "TEK",
                "1-30": 410,
                "30-60": 0,
                "60-90": 560,
                paymentDate: "03 Jul, 2025",
              },
              {
                clientName: "IBM",
                "1-30": 110,
                "30-60": 0,
                "60-90": 560,
                paymentDate: "03 Jul, 2025",
              },
              {
                clientName: "IBM",
                "1-30": 70,
                "30-60": 0,
                "60-90": 560,
                paymentDate: "03 Jul, 2025",
              },
              {
                clientName: "IBM",
                "1-30": 210,
                "30-60": 0,
                "60-90": 560,
                paymentDate: "03 Jul, 2025",
              },
              {
                clientName: "IBM",
                "1-30": 150,
                "30-60": 0,
                "60-90": 560,
                paymentDate: "03 Jul, 2025",
              },
              {
                clientName: "IBM",
                "1-30": 320,
                "30-60": 0,
                "60-90": 560,
                paymentDate: "03 Jul, 2025",
              },
              {
                clientName: "IBM",
                "1-30": 210,
                "30-60": 0,
                "60-90": 560,
                paymentDate: "03 Jul, 2025",
              },
            ]}
            barChartProps={{
              depth: 300,
            }}
            chartLabel={"clientName"}
            chartValue={"1-30"}
            chartToolbarRight={{
              expand: false,
              chartToggle: true,
            }}
          />
        </div>

        <div className="bg-[#FAFCFF] h-[420px] flex flex-col px-3 py-4 border border-gray-200 rounded-2xl shadow-lg col-span-2">
          <ChartNew
            type="areachart"
            title="Revenue Flow Analysis"
            expandedContent={renderRevenueExpandContent()}
            expandedChartWidth="w-[95%]"
            barColors={[
              { color: "primary" },
              { color: "info" },
              { color: "leave" },
              { color: "draft", depth: 500 },
              { color: "success" },
            ]}
            barChartProps={{
              depth: 300,
            }}
            rawData={[
              { label: "Jan", value: 60, invoices: 70, revenue: 60 },
              { label: "Feb", value: 90, invoices: 70, revenue: 60 },
              { label: "Mar", value: 130, invoices: 70, revenue: 60 },
              { label: "Apr", value: 125, invoices: 70, revenue: 60 },
              { label: "May", value: 100, invoices: 7, revenue: 60 },
              { label: "Jun", value: 145, invoices: 70, revenue: 60 },
              { label: "Jul", value: 155, invoices: 70, revenue: 60 },
              { label: "Aug", value: 130, invoices: 70, revenue: 60 },
              { label: "Sep", value: 105, invoices: 70, revenue: 60 },
              { label: "Oct", value: 100, invoices: 70, revenue: 60 },
              { label: "Nov", value: 120, invoices: 70, revenue: 60 },
              { label: "Dec", value: 160, invoices: 70, revenue: 60 },
            ]}
            width="w-full"
            height="h-full"
            chartLabel={"label"}
            chartValue={"value"}
            backgroundColor="bg-[#FAFCFF]"
            minPointGap={72}
            formatYAxisTick={(val) => `$ ${val}`}
            steps={3}
            areaChartProps={{
              steps: 5,
              depth: 400,
              renderToolTip: (data) => (
                <div className="flex flex-col gap-3 text-sm">
                  <span className="text-primary">{data.label}</span>
                  <div className="bg-primary-50 text-gray-600 text-xs font-medium w-[100px] flex justify-between p-2 rounded shadow-md">
                    Revenue:{" "}
                    <span className="text-primary">{data.revenue}</span>
                  </div>
                  <div className="bg-primary-50 text-gray-600 text-xs font-medium w-[100px] flex justify-between p-2 rounded shadow-md">
                    Invoices:{" "}
                    <span className="text-primary">{data.invoices}</span>
                  </div>
                </div>
              ),
            }}
          />
        </div>

        <div className="bg-[#FAFCFF] h-[340px] flex flex-col px-3 py-4 border border-gray-200 rounded-2xl shadow-lg col-span-2 lg:col-span-1">
          <h5 className="text-lg mb-3">Reserved Detailed Report</h5>
          {/* <Chart
          type="tablechart"
          title="Pending Timesheets"
          height="h-fit"
          columns={[
            {
              key: "empcode",
              label: "Emp Code",
            },
            { key: "empname", label: "Emp Name" },
            { key: "client", label: "Client" },
            {
              key: "period",
              label: "Period",
            },
            { key: "status", label: "Status" },
          ]}
          rows={[
            {
              empcode: 11234,
              empname: "$ 20000",
              client: "Vikranth",
              period: "Seaglass",
              status: (
                <Chip
                  size="sm"
                  label="Pending"
                  color="danger"
                  className="text-danger font-semibold rounded-xl px-3 py-1"
                />
              ),
            },
          ]}
        /> */}

          <ChartNew
            title="Pending Timesheets"
            expandIcon={false}
            type="tablechart"
            barColors={[
              { color: "primary" },
              { color: "info" },
              { color: "leave" },
              { color: "draft", depth: 500 },
              { color: "success" },
            ]}
            rawData={[
              {
                "Emp Code": 12345,
                "Emp Name": "$ 20000",
                Client: "Vikranth",
                Period: "Seaglass",
                Status: (
                  <Chip
                    size="sm"
                    label="Pending"
                    color="danger"
                    className="text-danger font-semibold rounded-xl px-3 py-1"
                  />
                ),
              },
            ]}
            chartToolbarRight={{}}
          />

          <ChartNew
            title="Pending Timesheets"
            expandIcon={false}
            type="tablechart"
            barColors={[
              { color: "primary" },
              { color: "info" },
              { color: "leave" },
              { color: "draft", depth: 500 },
              { color: "success" },
            ]}
            rawData={[
              {
                "Emp Code": 12345,
                "Emp Name": "$ 20000",
                Client: "Vikranth",
                Period: "Seaglass",
                Status: (
                  <Chip
                    size="sm"
                    label="Pending"
                    color="success"
                    className="text-success font-semibold rounded-xl px-3 py-1"
                  />
                ),
              },
            ]}
            chartToolbarRight={{}}
          />
        </div>

        <div className="bg-[#FAFCFF] h-[340px] px-3 py-4 border border-gray-200 rounded-2xl shadow-lg col-span-2 lg:col-span-1">
          <ChartNew
            type="tablechart"
            title="Infographic Bar"
            chartToolbarRight={{}}
            rawData={[
              {
                documentType: "H1B",
                candidateName: "Vikranth",
                expiryDate: "09/20/2025",
                expiryIn: (
                  <Chip label="4 Days" variant="text" color="success" />
                ),
              },
              {
                documentType: "H1B",
                candidateName: "Chandan",
                expiryDate: "09/20/2025",
                expiryIn: (
                  <Chip label="-2 Days" variant="text" color="danger" />
                ),
              },
              {
                documentType: "H1B",
                candidateName: "Omkar",
                expiryDate: "09/20/2025",
                expiryIn: (
                  <Chip label="4 Days" variant="text" color="success" />
                ),
              },
              {
                documentType: "H1B",
                candidateName: "Ershad",
                expiryDate: "09/20/2025",
                expiryIn: (
                  <Chip label="3 Days" variant="text" color="success" />
                ),
              },
              {
                documentType: "H1B",
                candidateName: "Chandan",
                expiryDate: "09/20/2025",
                expiryIn: (
                  <Chip label="-2 Days" variant="text" color="danger" />
                ),
              },
              {
                documentType: "H1B",
                candidateName: "Ershad",
                expiryDate: "09/20/2025",
                expiryIn: (
                  <Chip label="3 Days" variant="text" color="success" />
                ),
              },
            ]}
          />
        </div>

        <Drawer
          isOpen={isOPenWidget}
          onClose={() => setIsOpenWidget(false)}
          position="right"
          width="w-[50%]"
          title="Add Widgets"
          closeOnOutsideClick
        >
          <div className="flex flex-col px-5 py-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
              {widgets.map((item, _idx) => (
                <div
                  key={_idx}
                  className={`flex flex-col gap-3 w-full ${
                    selectedWidgets.includes(item)
                      ? `text-success border-success`
                      : `text-dark border-gray-200`
                  } items-center px-2 py-5 border rounded-xl hover: cursor-pointer hover:shadow-lg`}
                  onClick={() => handleSelectWidgets(item)}
                >
                  <Button
                    type="icon"
                    size="2xl"
                    icon={"check_circle"}
                    variant="text"
                    color={`${
                      selectedWidgets.includes(item) ? `success` : `black`
                    }`}
                  />
                  <span>{item}</span>
                </div>
              ))}
            </div>

            <div className="flex justify-end items-center gap-5 mt-30">
              <Button
                title={"Cancel"}
                variant="outlined"
                onClick={() => setIsOpenWidget(false)}
              />

              <Button title={"Done"} onClick={() => setIsOpenWidget(false)} />
            </div>
          </div>
        </Drawer>
        <Modal
          isOpen={revenueFlowModalOpen}
          title={"Invoice Details"}
          onClose={() => setRevenueFlowModalOpen(null)}
          showCloseButton={true}
          closeOnOutsideClick={true}
          width="max-w-full"
          zIndex={56}
        >
          <RevenueFlowKpiViewModal
            onClose={() => setRevenueFlowModalOpen(false)}
            data={null}
          />
        </Modal>
      </div>
    </div>
  );
};

export default MainDashboard;
